export const isPTLIndentType = indentDeliveryType =>
  indentDeliveryType && indentDeliveryType === 'PTL';

/**
 *
 * @param {*} indentDeliveryType
 * Input string as FTL
 */
export const isFTLIndentType = indentDeliveryType =>
  indentDeliveryType && indentDeliveryType === 'FTL';

export const isPerCFT = type =>
  type && type === 4;

export const isPerTon = type =>
  type && type === 2;

export const getPanValidation = panNo => {
  let isValid = true;
  if (!panNo) {
    isValid = false;
  }

  if (panNo.length !== 10) {
    isValid = false;
  }

  if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNo)) {
    isValid = false;
  }
  return isValid;
}